import React, { useState, useRef, useCallback } from 'react';
import { GoogleMap, Marker, useJsApiLoader, MarkerClusterer } from '@react-google-maps/api';
import { API_KEY_GOOGLE_MAP } from '../constantes/generales';

const containerStyle = {
  width: '100%',
  minHeight: '400px', 
  height: '100%',
  minHeight: '400px'
};


const Mapa = ({zoom=14, center, letMoveCentro=false, updatePosicion}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: API_KEY_GOOGLE_MAP
  });

  const mapRef = useRef(null);
  const [posicion, setPosicion] = useState(center);

  const onLoad = useCallback((map) => {
    mapRef.current = map;
    updatePosicion("ACTUALIZAR_UBICACION", posicion); 
  }, []);

  const onCenterChanged = useCallback(() => {

    if (!mapRef.current) return;
    const newPos = mapRef.current.getCenter().toJSON();
    const antPos=posicion;

    if(letMoveCentro && (newPos.lat!==antPos.lat || newPos.lng!==antPos.lng)){  
        updatePosicion("ACTUALIZAR_UBICACION", newPos); 
        setPosicion(newPos);
    }    

  }, []); // Depend on mapRef


  if (!isLoaded) return <div>Loading...</div>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center} // Controlled prop
      zoom={zoom}
      onLoad={onLoad}
      onCenterChanged={onCenterChanged} // Use this callback
      id="map"
    >
        <Marker position={posicion} />
        
    </GoogleMap>
  );
};

export default Mapa;